export default "GTB classe B/A (EN 15232) : pilotage CVC, éclairage, ECS. Fiche CEE BAT-TH-116. Obligation BACS pour bâtiments > 290 kW d'ici 2027. Levier OPERAT prioritaire.";
